

import { Box, FormHelperText, TextField, Typography, FormControlLabel, Checkbox, Button,Tooltip, IconButton, InputAdornment, OutlinedInput  , List , ListItem , Table , TableBody , TableCell , TableContainer , TableHead  , TableRow , Paper , TextareaAutosize , Select , MenuItem , FormControl , RadioGroup , Radio ,Tabs  , Tab , Switch , styled , Modal  , Menu , Collapse , Stack,  Pagination, SwipeableDrawer , Accordion , AccordionActions , AccordionDetails , AccordionSummary } from "@mui/material";

import { Link } from "react-router-dom";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OwlCarousel from 'react-owl-carousel3';
import { motion } from "framer-motion"







export default {
      Box,
      FormHelperText,
      TextField,
      Typography,
      FormControlLabel,
      Checkbox,
      Button,
      IconButton,
      Tooltip,
      InputAdornment,
      OutlinedInput,
      VisibilityOff,
      Visibility,
      Link,
      List,
      ListItem,
      Table, 
      TableBody, 
      TableCell, 
      TableContainer, 
      TableHead,
      TableRow,
      Paper,
      TextareaAutosize,
      Select,
      MenuItem,
      FormControl,
      RadioGroup,
      Radio,
      Tabs,
      Tab,
      Switch ,
      styled ,
      Modal ,
      Menu,
      ExpandLess,
      ExpandMore,
      Collapse,
      Stack,
      Pagination,
      SwipeableDrawer,
      Accordion,
      AccordionActions,
      AccordionDetails,
      AccordionSummary,
      ExpandMoreIcon,
      OwlCarousel,
      motion,
};
